<template>
  <footer
    v-if="settingDatas.home"
    class="footer"
  >
    <div class="footer-content">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="d-flex flex-column boxlogo">
              <b-link
                class="navbar-brand align-middle d-flex"
                to="/"
              >
                <span class="brand-logo">
                  <b-img
                    :src="appLogoImage"
                    alt="logo"
                  />
                </span>
                <h2 class="brand-text align-middle">
                  {{ appName }}
                </h2>
              </b-link>
              <h3 class="text font-weight-bolder">
                News Portal - Cổng tin tức<br> đài tiếng nói việt nam
              </h3>
            </div>
          </div>
          <div class="col-12 col-md-8 navlink mt-xs-2">
            <div class="row">
              <div class="col-12 col-md-4">
                <h3 class="text-uppercase">
                  WebSite
                </h3>
                <div v-html="settingDatas.home.weblinks" />
              </div>
              <div class="col-12 col-md-4 mt-xs-1">
                <h3 class="text-uppercase">
                  Đơn vị quản lý
                </h3>
                <div v-html="settingDatas.home.organization" />
              </div>
              <div class="col-12 col-md-4 mt-xs-1">
                <h3 class="text-uppercase">
                  Liên hệ
                </h3>
                <div v-html="settingDatas.home.contact" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copy-right">
      <div class="container">
        <p class="m-0">
          Bản quyền tin tức của Đài TNVN, nghiêm cấm sao chép,phổ biến ra bên ngoài nếu không được cho phép
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
import {
  BImg,
  BLink,
} from 'bootstrap-vue';
import { $themeConfig } from '@themeConfig'
import useSettings from '@/views/setting/useSettings';

export default {
  components: {
    BImg,
    BLink,
  },
  setup(props) {
    const { appName, appLogoImage } = $themeConfig.app

    const {
      settingDatas,
    } = useSettings()
    return {
      appName,
      appLogoImage,
      settingDatas,
    }
  },
}
</script>
